module.exports = __webpack_public_path__ + "assets/img/role-38f240ab.png";